import React, { useState } from "react";
import styled from "styled-components";
import ExtensionSearch from "./ExtensionSearch";

const TransferDealContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
`;

const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(252, 252, 252, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;

const Spinner = styled.div`
    width: 24px;
    height: 24px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const StyledText = styled.p`
    color: #666;
    font-size: 14px;
    margin: 0;
`;

const ExtensionTransferDealPage = ({ target, setTarget, transferDealLoading }) => {
    const [profile, setProfile] = useState(null);
    return (
        <TransferDealContainer>
            {transferDealLoading && (
                <LoadingOverlay>
                    <Spinner />
                </LoadingOverlay>
            )}
            <StyledText>Search profile for deal transfer</StyledText>
            {profile && (
                <StyledText>
                    Selected profile:{" "}
                    <b>
                        {profile.ad} {profile.soyad}
                    </b>
                </StyledText>
            )}
            <ExtensionSearch optionClick={(targetId) => setTarget(targetId)} setProfile={setProfile} />
        </TransferDealContainer>
    );
};

export default ExtensionTransferDealPage;
